import React, { FC } from 'react';
import styles from './ShoppingCart.module.scss';
import { ReactComponent as ArrowGoBack } from 'images/new-icons/arrow-go-back.svg';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: () => void;
  text: string;
};
const Header: FC<Props> = ({ onClose, text }) => {
  const {t} = useTranslation() as any
  return (
    <div className={styles.menu__profile_header}>
      <ArrowGoBack onClick={onClose} />
      <div className={styles.menu__profile_title}>{t(text)}</div>
    </div>
  );
};

export default Header;
